import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-imagens-fullscreen',
  standalone: true,
  imports: [CommonModule, MatDialogModule], 
  templateUrl: './imagens-fullscreen.component.html',
  styleUrl: './imagens-fullscreen.component.scss'
})
export class ImagensFullscreenComponent {
  imagens: string[];
  imagensThumb: string[];
  selectedImageIndex: number = 0;

  private popStateListener = () => this.fecharModal(true);

  constructor(
    public router: Router,
    public dialogRef: MatDialogRef<ImagensFullscreenComponent>,
    @Inject(MAT_DIALOG_DATA) public data: {indexSelected:number; imagens: string[]; imagensThumb: string[] }
  ) {
    this.imagens = data.imagens;
    this.imagensThumb = data.imagensThumb;
    this.selectedImageIndex = data.indexSelected;

      // Adiciona uma entrada no histórico ao abrir o diálogo
    history.pushState(null, '', location.href);

    // Escuta o botão de voltar do navegador
    window.addEventListener('popstate', this.popStateListener);

    // Remove o listener se o usuário fechar o modal manualmente
    this.dialogRef.afterClosed().subscribe(() => {
      window.removeEventListener('popstate', this.popStateListener);

      // Volta um passo no histórico (só se ainda não voltou)
      if (history.state === null) history.back();
    });

  }
 fecharModal(triggeredByBackButton = false) {
    // Fecha o modal e deixa o popstate limpar o histórico
    this.dialogRef.close();

    if (triggeredByBackButton) {
      // Se o fechamento for manual (ex: botão fechar), volta no histórico
      history.back();
    }
  }
  avancar() {
    this.selectedImageIndex = (this.selectedImageIndex + 1) % this.imagens.length;
  }

  voltar() {
    this.selectedImageIndex = (this.selectedImageIndex - 1 + this.imagens.length) % this.imagens.length;
  }

  selecionarImagem(index: number) {
    this.selectedImageIndex = index;
  }
  
}